import React  from 'react';
import Popup from '../popups/popup';
import { connect } from "react-redux";
import CompleteAccountModal from "../listing/completeAccountModal";

class PopupCompleteYourAccount extends Popup {
    constructor(props) {
        super(props);
    }
    static initPopup(props = {}) {
        props.stopAnimation ? props.stopAnimation() : null;
        Popup.initPopup.call(this, props);

        this.props = props;
    }

    _onPopupClose() {
        if (this.props.stopAnimation) {
            this.props.stopAnimation();
        }
    }

    content() {
        const {version, userActionsCb} = this.props
        return <div className='complete-your-account-popup'>
            <CompleteAccountModal
                version={ version }
                item={ this.props.item }
                userActionsCb={ userActionsCb }
            />
        </div>;
    }
}

PopupCompleteYourAccount.defaultProps = {
    popupClassName: 'popup-complete-your-account',
    single: true,
    modal: true,
    onPopupClose: function() {
        this._onPopupClose();
    }
};

const mapStateToProps = ({ Item, ADO }) => {
    return {
        item: Item,
        ADO
    }
};

export default connect(mapStateToProps)(PopupCompleteYourAccount);
